export interface UploadProgress {
    percent: number;
}

export interface NewUploadFilesValue {
    _id: null | string;
    upFile: File;
    percent: number;
    finish: boolean;
}

export enum TEMPLATE_FILE_NAME {
    CONTACTS_MEMBER_ROLE_REL_IMPORT_TEMPLATE = 'contacts_member_role_rel_import_template', // 通讯录角色导入
    CONTACTS_EXTERNAL_MEMBER_ROLE_REL_IMPORT_TEMPLATE = 'contacts_external_member_role_rel_import_template', // 外部角色导入
    CONTACTS_CORP_CORP_IMPORT_TEMPLATE = 'contacts_corp_coop_import_template', // 互联组织批量导入
    CONTACTS_BULK_IMPORT_TEMPLATE = 'contacts_bulk_import_template', // 通讯录导入
    CONTACTS_EXTERNAL_MEMBER_IMPORT_TEMPLATE = 'contacts_external_member_import_template', // 外部成员导入
    CONTACTS_EXTERNAL_EXEMPT_TRIAL_IMPORT_TEMPLATE = 'external_direct_user_provisioning_import_template', // 外部成员免审导入模板
    CONTACTS_EXEMPT_TRIAL_IMPORT_TEMPLATE = 'direct_user_provisioning_import_template', // 通讯录成员免审导入模板
    REAL_NAME_CERTIFICATION_LETTER = 'real_name_certification_letter' // 简道云公函
}

// 文件基本信息 - 公开桶图片存储场景
export interface IFileBaseInfo {
    key?: string;
    bucket?: string;
    mime?: string;
    name?: string;
    size?: number;
}

export enum SelectMemberType {
    USER = 'user',
    ROLE = 'role',
    DEPARTMENT = 'department',
    DYNAMIC = 'dynamic',
    CONTACTS = 'contacts'
}

/**
 * 通用范围定义
 * 0：部分 ，1：全部
 *
 * @example 管理员->部门范围/角色范围 全部角色/部分角色, API Key 应用/api授权范围 全部/部分 etc.
 */
export enum RANGE_TYPE {
    PARTIAL = 0,
    ALL = 1
}

export interface ISearchParams {
    keyword?: string;
    limit?: number;
    skip?: number;
}
